import styled, { css } from 'styled-components';
import { rem } from 'polished';
import variables from '@styles/variables';
import Config from '@config';
import Heading from '@atoms/Heading/Heading';
import Text from '@atoms/Text/Text';

export const StyledNotFoundText = styled.div`
  padding-top: ${rem(24)};
  padding-bottom: ${rem(24)};
`;

export const StyledProductDetailsWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledProductDetails = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;

  ${Config.MEDIA.FROM_TABLET_LANDSCAPE} {
    flex-direction: row;
  }
`;

export const StyledProductDetailsEnergyDeclaration = styled.div`
  border-top: ${rem(1)} solid ${variables.colors.mediumGray};
  padding-top: ${rem(27)};
  margin-top: ${rem(27)};
`;

export const StyledHeading = styled(Heading)`
  margin-bottom: ${rem(12)};
`;

export const StyledProductDetailsRight = styled.div<{ $isPage?: boolean }>`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  ${(props) =>
    props.$isPage &&
    css`
      ${Config.MEDIA.IS_MOBILE} {
        border-bottom: ${rem(1)} solid ${variables.colors.mediumGray};
      }
    `}
`;

export const StyledProductDetailsRightTop = styled.div`
  padding: ${rem(20)};
  width: 100%;

  ${Config.MEDIA.FROM_TABLET_PORTRAIT} {
    padding: ${rem(35)};
  }

  ${Config.MEDIA.FROM_TABLET_LANDSCAPE} {
    padding: ${rem(40)};
  }
`;

export const StyledProductDetailsManufacturerWrapper = styled.div`
  display: flex;
  gap: ${rem(5)};
  align-items: baseline;
  margin-bottom: ${rem(20)};
`;

export const StyledManufacturer = styled(Text)`
  text-transform: uppercase;
`;

export const StyledProductDetailsQuantityField = styled.div`
  width: 100%;
  margin-bottom: ${rem(50)};
  max-width: ${rem(180)};
`;

export const StyledProductDetailsRightBottom = styled.div`
  width: 100%;
`;

export const StyledProductDetailsPriceAndPromotion = styled.div`
  margin-bottom: ${rem(16)};
`;

export const BreadcrumbsWrapper = styled.div<{ $isPage?: boolean }>`
  margin-bottom: ${rem(18)};

  ${(props) =>
    props.$isPage &&
    css`
      padding: ${rem(20)};
      ${Config.MEDIA.FROM_TABLET_PORTRAIT} {
        padding: ${rem(40)};
        margin: 0;
      }
    `}
`;
